import { mixins } from 'vue-class-component';
import { Component, Prop, Watch } from 'vue-property-decorator';
import FieldWrapper from '../field-wrapper/field-wrapper.vue';
import AbstractField from '../abstract-field/abstract-field';
import 'vue-select/dist/vue-select.css';
import EntityTableProvider from '@shared/components/tables/entity-table-provider/entity-table-provider.vue';
import AbstractTable from '@shared/components/tables/abstract-table/abstract-table';
import EntityTable from '@shared/components/tables/entity-table/entity-table.vue';
const ConfirmationModal = () =>
  import('@shared/components/modals/confirmation-modal/confirmation-modal.vue');
const StandardForm = () => import('../../auto-form/std-form/std-form.vue');
const EntityDeleteModalProvider = () =>
  import('@shared/components/modals/entity-delete-modal-provider/entity-delete-modal-provider.vue');

import { library } from '@fortawesome/fontawesome-svg-core';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import DrawerModal from '@shared/components/modals/drawer-modal/drawer-modal.vue';
import StdFilter from '@shared/components/filters/std-filter/std-filter.vue';
import CustomFilterSelector from '@shared/components/filters/custom-filter-selector/custom-filter-selector.vue';
import ExtendedFilter from '@shared/components/filters/extended-filter/extended-filter.vue';
import { v4 as uuidv4 } from 'uuid';
import EntityFormProvider from '@shared/components/forms/auto-form/entity-form-provider/entity-form-provider';
import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';

library.add(faPlus);
const SubscriptionForm = () =>
  import('@subscriptions/components/forms/subscription-form/subscription-form.vue');

@Component({
  name: 'bpc-subscription-table-input',
  components: {
    'bpc-entity-table-provider': EntityTableProvider,
    'bpc-entity-delete-modal-provider': EntityDeleteModalProvider,
    'bpc-std-form': StandardForm,
    'bpc-entity-table': EntityTable,
    'bpc-field-wrapper': FieldWrapper,
    'bpc-confirmation-modal': ConfirmationModal,
    'font-awesome-icon': FontAwesomeIcon,
    'bpc-drawer-modal': DrawerModal,
    'bpc-std-filter': StdFilter,
    'bpc-custom-filter-selector': CustomFilterSelector,
    'bpc-extended-filter': ExtendedFilter,
    'bpc-subscription-form': SubscriptionForm,
  },
})
export default class SubscriptionTableInput extends mixins(AbstractField, AbstractTable) {
  declare $refs: AbstractTable['$refs'] & {
    stdCancelForm: InstanceType<typeof StdForm> & {
      formModel: any;
      formProvider: EntityFormProvider;
    };
  };
  @Prop(Array) readonly value: any[];

  @Prop(String) readonly selectEntity: string;
  @Prop(String) readonly selectPluralEntity: string;

  @Prop({ type: String, default: 'drawer' }) readonly type: string;
  @Prop({ type: String, default: 'table-input' }) declare readonly displayConfigName: string;

  @Prop(String) readonly fieldForStorage: string;

  @Prop(Boolean) readonly withDraft: boolean;

  @Prop(String) readonly editFormConfigName: string;
  @Prop(String) readonly permissionEntityName: string;

  @Prop({ type: Boolean, default: false }) readonly withFilters: boolean;
  @Prop({ type: Boolean, default: false }) readonly withCustomFilters: boolean;
  @Prop({ type: Boolean, default: false }) readonly withTabFilters: boolean;
  @Prop({ type: String, default: 'inputTable' }) declare readonly storeName: string;
  @Prop({ type: String, default: 'bpc-std-form' }) declare readonly formComponent: string;

  @Prop({
    type: Array,
    default: () => ['configLoaded', 'paginationLoaded', 'orderLoaded'],
  })
  readonly customFlagsToCheckBeforeLoadEntities: Array<any>;

  get model(): any[] {
    return this.value;
  }
  set model(val: any[]) {
    this.$emit('input', val);
    if (this.eventsConfig && this.eventsConfig.emit) {
      this.eventsConfig.emit.forEach(event => {
        this.$root.$emit(event, val);
      });
    }
  }

  get showCreateButton(): boolean {
    if (this.isDisabled) {
      return false;
    } else {
      return this.$attrs.showCreateButton ? this.$attrs.showCreateButton === 'true' : true;
    }
  }

  get formComponentName(): string {
    switch (this.formComponent) {
      case 'subscription-form':
        return 'bpc-subscription-form';
      default:
        return 'bpc-std-form';
    }
  }

  @Watch('value')
  updateItemsProvider() {
    this.$refs.provider.items = this.value;
    if (this.value) {
      if (this.getMode() == 'storage') {
        this.$bpcStorage.set(this.selectPluralEntity, this.value);
      }
      this.updateRowsActions();
    }
    console.log('change items provider');
  }

  public entity: any = null;
  public entityName = null;
  public pluralEntityName = null;

  beforeMount() {
    this.entityName = this.selectEntity;
    this.pluralEntityName = this.selectPluralEntity;
    this.permissionEntityNameToUse = this.permissionEntityName;
  }

  mounted() {
    if (this.$eventsService.events[this.entityName]) {
      this.$eventsService.events[this.entityName].mounted(this);
    }
    this.$root.$on('refresh-table-after-add-orders-to-pos', () => {
      this.refreshEntitiesAfterOrdersAddedToPosCheckout();
    });
    this.$root.$on('triggerActionInEntityTableInput', event => {
      this.triggerPageActions(event);
    });
    this.$root.$on('new-access-control-badge-created', () => {
      this.getEntities();
    });
    if (this.getMode() === 'storage') {
      // WARNING: I think that it doesn't have impact, but if we have problems in the entity table input we should see this line
      this.$bpcStorage.clear(this.pluralEntityName);
    }
  }
  destroyed() {
    if (this.$eventsService.events[this.entityName]) {
      this.$eventsService.events[this.entityName].destroy(this);
    }
    this.$root.$off('refresh-table-after-add-orders-to-pos');
    this.$root.$off('new-access-control-badge-created');
  }

  getEntities() {
    this.$refs.provider.getEntities();
  }

  private modelLoaded;
  onModelLoaded(event) {
    this.modelLoaded = JSON.parse(JSON.stringify(this.$refs.stdForm?.formModel));
  }

  onChange($event) {
    this.$emit('change', $event);
  }

  // TODO: Determine if model has ID or not to consume api or create in localstorage.
  getMode(): string {
    const filter = this.filters.find(filter => filter['filterField'] == this.fieldForStorage);
    if (filter['value']) {
      return 'api';
    } else {
      return 'storage';
    }
  }
  updateModel(): void {
    this.model = this.$refs.provider ? this.$refs.provider.items : null;
  }

  onFormSave(nextAction: string = '') {
    if (this.$refs.stdForm.formModel.status === 'cancelled' && this.entity.status !== 'cancelled') {
      this.$bvModal.msgBoxOk(this.$t('global.use_corresponding_cancel_action') as string, {
        okTitle: this.$t('global.buttons.accept') as string,
        title: ((this.$t('global.modals.edit') as string) +
          ' ' +
          this.$t('global.models.booking.name')) as string,
      });
    } else {
      this.isSavingForm = true;
      console.log('Saving');
      this.nextAction = nextAction;
      const filter = this.filters.find(filter => filter['filterField'] == this.fieldForStorage);
      if (filter['value']) {
        this.$refs.stdForm.formModel[filter['filterField']] = filter['value'];
      }
      this.$refs.stdForm.saveEntity();
    }
  }

  onFormSaveAndPay() {
    this.onFormSave('pay');
  }

  onNew() {
    this.entity = null;
    this.showForm = true;
    if (this.type === 'drawer') {
      // this.$bvModal.show('modal-resource-form');
      this.showDrawerSection = true;
    } else if (this.type === 'modal') {
      this.$bvModal.show(`${this.selectEntity}-entity-table-input-modal`);
    }
    this.disabledForm = false;
  }

  onEdit(e, disabled = false) {
    console.log('clickOnEdit', e);
    this.entity = e.item;
    this.showForm = true;
    if (this.type === 'drawer') {
      this.showDrawerSection = true;
    } else if (this.type === 'modal') {
      this.$bvModal.show(`${this.selectEntity}-entity-table-input-modal`);
    }
    setTimeout(() => {
      this.disabledForm = disabled;
    });
  }

  onFormClose() {
    this.showForm = false;
    if (this.type === 'drawer') {
      this.showDrawerSection = false;
    } else if (this.type === 'modal') {
      this.$bvModal.hide(`${this.selectEntity}-entity-table-input-modal`);
    }
    this.showDrawerSection = false;
  }

  get showedFields() {
    const showedFields = [];
    for (const field of this.$refs.provider.fields) {
      if (!field['conditionalShow']) {
        showedFields.push(field);
      } else {
        const keys = field['conditionalShow']['fieldPath'].split('.');
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        let conditionalValue = this;
        for (const key of keys) {
          if (conditionalValue[key] != 'undefined') {
            conditionalValue = conditionalValue[key];
          } else {
            break;
          }
        }
        if (conditionalValue === field['conditionalShow']['value']) {
          showedFields.push(field);
        }
      }
    }
    return showedFields;
  }

  get availableToSaveAndPay() {
    return ['enrollment', 'subscription'].includes(this.entityName);
  }

  onFormSaved($event: any = null) {
    if (this.nextAction === 'new') {
      this.setEntityAttributesAfterSave();
      this.$refs.provider.getEntities();
    } else if (this.nextAction === 'pay') {
      // Pay Subscriptions
      if (this.entityName === 'subscription') {
        const orders = [];
        const contacts = [];
        const priceCategories = [];
        $event.data?.forEach(subscription => {
          subscription.orders.forEach(order => orders.push(order));
          if (!contacts.includes(subscription.contact_id)) {
            contacts.push(subscription.contact_id);
          }
          if (!priceCategories.includes(subscription.price_category_id)) {
            priceCategories.push(subscription.price_category_id);
          }
        });
        this.ordersAvailableToPosCheckout = orders;
        this.selectedOrdersToPosCheckout = orders;
        this.selectedContactIdToPosCheckout = contacts.length > 1 ? null : contacts[0];
        this.selectedPriceCategoryIdToPosCheckout =
          priceCategories.length > 1 ? null : priceCategories[0];
      } else {
        this.ordersAvailableToPosCheckout = $event.data?.orders;
        this.selectedOrdersToPosCheckout = $event.data?.orders;
        this.selectedContactIdToPosCheckout = $event.data?.contact_id;
        this.selectedPriceCategoryIdToPosCheckout = $event.data?.price_category_id;
      }
      this.selectedInvoiceIdToPosCheckout =
        this.$store.getters['pos/currentTicket']?.status === 'to_pay'
          ? this.$store.getters['pos/currentTicket']
          : null;
      this.onFormClose();
      this.$refs.provider.getEntities();
      this.openExportPosCheckoutModal();
    } else {
      this.onFormClose();
      this.$root.$emit(this.entityName + '-table-input-form-saved');
      this.$refs.provider.getEntities();
    }
    this.isSavingForm = false;
  }

  // Manage action to cancel entity
  public selectedRowEntity = null;

  get cancelEntityModalId() {
    return uuidv4();
  }

  customOnRowAction($event: { event: string; item: any }) {
    switch ($event.event) {
      case 'cancel':
        this.onOpenCancelModal($event.item.item);
        break;
    }
  }

  extendUpdateRowActions(entity: any) {
    const hasCancelPermission = this.$authorizationService.hasPermissionForAction(
      this.permissionEntityNameToUse ? this.permissionEntityNameToUse : this.pluralEntityName,
      'cancel',
    );

    entity.actions.cancel.show = entity.can_be_cancelled && hasCancelPermission;
    return null;
  }

  onOpenDeleteModal(entity) {
    this.$refs.softDeleteConfirmationModal.onOpenModal(entity.id);
  }

  onSuccessSoftDelete() {
    this.$refs.softDeleteConfirmationModal.onCloseModal();
    this.$refs.provider.getEntities();
    this.onFormClose();
  }

  onOpenCancelModal(entity) {
    this.selectedRowEntity = entity;
    this.$bvModal.show(this.cancelEntityModalId);
  }

  onCloseCancelModal() {
    this.selectedRowEntity = null;
    this.$bvModal.hide(this.cancelEntityModalId);
    this.onFormClose();
  }

  onConfirmCancelEntity() {
    const basePath = this.$bpcApiRouteHelper.getEntityPath(this.pluralEntityName);
    const relativePath = '/cancel/' + this.selectedRowEntity.id;
    this.$bpcApi
      .put(basePath + relativePath, {
        id: this.selectedRowEntity.id,
        cancel_reason: this.$refs.stdCancelForm.formModel['cancel_reason'],
        cancel_reason_description: this.$refs.stdCancelForm.formModel['cancel_reason_description'],
        cancel_orders: this.$refs.stdCancelForm.formModel['cancel_orders'],
        notify_by_email:
          'notify_by_email' in this.$refs.stdCancelForm.formModel
            ? this.$refs.stdCancelForm.formModel['notify_by_email']
            : true,
      })
      .subscribe(
        res => {
          this.$bpcMessage.showSuccessMessage({ text: 'global.generic.successful_action' });
          this.$refs.provider.getEntities();
        },
        error => {
          this.$bpcMessage.showErrorMessage({
            text: 'global.generic.error_form_action',
          });
        },
        () => {
          this.onCloseCancelModal();
        },
      );
  }

  get availableToPosCheckout(): boolean {
    return (
      this.$authorizationService.hasPermissionForAction('pos_sessions', 'pos_checkout', true) &&
      this.openPosSession &&
      this.entity?.orders &&
      this.entity?.orders.some(
        order =>
          order.status === 'waiting' ||
          (order.type === 'attendee' && order.status === 'shopping_cart'),
      )
    );
  }

  // FIXME Use an interface payableEntity to extract always the date in the same way for all entities that can be paid
  onFormClickToPay() {
    this.ordersAvailableToPosCheckout = this.entity?.orders;
    this.selectedOrdersToPosCheckout = this.entity?.orders;
    this.selectedContactIdToPosCheckout = this.entity?.attendee_id
      ? this.entity?.attendee_id
      : this.entity?.contact_id;
    this.selectedPriceCategoryIdToPosCheckout = this.entity?.attendee
      ? this.entity?.attendee?.price_category_id
      : this.entity?.contact?.price_category_id;
    this.selectedInvoiceIdToPosCheckout =
      this.$store.getters['pos/currentTicket']?.status === 'to_pay'
        ? this.$store.getters['pos/currentTicket']
        : null;
    this.openExportPosCheckoutModal();
  }

  triggerPageActions(event) {
    const action = event.action;
    const fieldName = event.fieldName;
    if (this.name == fieldName) {
      this.onPageAction(action);
    }
  }
}
